var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useState } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { usePopper } from 'react-popper';
import { twMerge } from 'tailwind-merge';
export var Tooltip = function (_a) {
    var text = _a.text, icon = _a.icon, _b = _a.iconClassName, iconClassName = _b === void 0 ? 'text-blue-500' : _b, wrapperClassName = _a.wrapperClassName, tooltipWrapperClassName = _a.tooltipWrapperClassName, _c = _a.placement, placement = _c === void 0 ? 'right' : _c, testSelector = _a.testSelector, _d = _a.triggerMode, triggerMode = _d === void 0 ? 'hover' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, className = _a.className;
    var _f = useState(null), referenceElement = _f[0], setReferenceElement = _f[1];
    var _g = useState(null), popperElement = _g[0], setPopperElement = _g[1];
    var _h = useState(false), open = _h[0], setOpen = _h[1];
    var _j = usePopper(referenceElement, popperElement, {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
        ],
        placement: placement,
    }), styles = _j.styles, attributes = _j.attributes, update = _j.update;
    var isHoverMode = triggerMode === 'hover';
    return (_jsxs("span", { ref: setReferenceElement, onMouseEnter: function () { return !disabled && isHoverMode && setOpen(true); }, onMouseLeave: function () { return !disabled && setOpen(false); }, onClick: function () { return !disabled && !isHoverMode && setOpen(!open); }, className: clsx(wrapperClassName), children: [icon || _jsx(FaQuestionCircle, { className: clsx('cursor-pointer', iconClassName) }), _jsx("span", __assign({ ref: setPopperElement, style: __assign(__assign({}, styles.popper), { zIndex: 9999 }), className: tooltipWrapperClassName }, attributes.popper, { children: _jsx(Transition, { as: "span", className: twMerge('inline-block px-1.5 max-w-xs py-1 text-xs transition-opacity bg-gray-600 text-white rounded-md shadow', className), enterFrom: "opacity-0", enterTo: "opacity-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", show: open, beforeEnter: function () { return update && update(); }, static: true, "data-cy": testSelector ? "".concat(testSelector, "-content") : 'tooltip-content', children: text }) }))] }));
};
